module.exports = __webpack_public_path__ + "img/45.8a3783bb.jpg";